// redirectTo
const redirectToKey = "redirectTo"

export const setRedirectTo = (value) => localStorage.setItem(redirectToKey, value)

export const getRedirectTo = () => localStorage.getItem(redirectToKey)

export const removeRedirectTo = () => localStorage.removeItem(redirectToKey)